module.exports = __webpack_public_path__ + "img/logo-text-default.325f15df.svg";